module.exports = __webpack_public_path__ + "static/media/bar.d5fb19d1.png";